import { useEffect } from "react";

function useReveal(rootRef, readyKey) {
  useEffect(() => {
    const root = rootRef?.current;
    if (!root) return undefined;

    const nodes = root.querySelectorAll("[data-reveal]");
    if (!nodes.length) return undefined;

    const showAll = () => {
      nodes.forEach((node) => node.classList.add("is-visible"));
    };

    if (typeof IntersectionObserver !== "function") {
      showAll();
      return undefined;
    }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      showAll();
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.16, rootMargin: "0px 0px -6% 0px" }
    );

    const viewport = window.innerHeight || 0;
    nodes.forEach((node) => {
      const box = node.getBoundingClientRect();
      if (box.bottom > 0 && box.top < viewport * 0.94) {
        node.classList.add("is-visible");
        return;
      }
      observer.observe(node);
    });
    return () => observer.disconnect();
  }, [rootRef, readyKey]);
}

export default useReveal;
